import script from "./QuestionHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionHeader.vue?vue&type=script&setup=true&lang=js"

import "./QuestionHeader.vue?vue&type=style&index=0&id=605885ed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-605885ed"]])

export default __exports__